export { default } from './PrintTemplate'
